function accessibleIframes() {
  const videos = document.getElementsByClassName('embed');
  const videoTitle = 'Click to view embedded video';

  if (videos) {
    for (const item of videos) {
      const iframe = item.firstElementChild;

      iframe.setAttribute('title', videoTitle);
    }
  }
}

window.onload = accessibleIframes;

export default accessibleIframes;
